module.exports = __webpack_public_path__ + "img/nightingale_available.cd4fa375.png";